import axiosHandler from '@/utils/axios-handler';
import { academyPath } from '@/lib/schema/paths';

/**
 * GET one of this app's /api/learner/* routes. axiosHandler, not fetch: its 401 handling is what
 * flags a possibly-expired session.
 */
export async function fetchLearner<T>(path: string, errorMessage: string): Promise<T> {
  const response = await axiosHandler({ method: 'GET', url: academyPath(`/api/learner/${path}`) });
  if ('status' in response && response.status === 200 && 'data' in response) {
    return response.data as T;
  }
  throw new Error(errorMessage);
}

/** GET an /api/learner/* route that answers `{ items }`. */
export async function fetchLearnerItems<T>(path: string, errorMessage: string): Promise<T[]> {
  return (await fetchLearner<{ items?: T[] }>(path, errorMessage))?.items ?? [];
}
